
  import { Component, Prop, Vue, Model } from "vue-property-decorator";

  import UPDATE_CUSTOM_REQUEST from "@/apollo/requests/UpdateCustomRequest.gql";

  import UIButton from "@/components/button/ui-button.vue";

  import { CustomRequestStatus } from "@/entities/CustomRequestStatus";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import { Manager } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";


  @Component({
    components: {
      UIButton,
    }
  })
  export default class CustomRequestActions extends Vue {
    @Prop({type: String, required: true}) readonly requestId!: string;
    @Prop({type: String, required: true}) readonly currentStatus!: string;
    @Prop({type: String, required: true}) readonly currentUserId!: string;
    @Prop({type: Boolean, default: false}) readonly isAdmin!: boolean;
    @Model('toggle', {type: Boolean, default: false}) readonly modalShown!: boolean;

    get isApplicantsSent():boolean {
      return this.currentStatus == CustomRequestStatus.APPLICANTS_SENT;
    }

    get isUnderReview():boolean {
      return this.currentStatus == CustomRequestStatus.UNDER_REVIEW;
    }

    get showStatusButtonForManager(): boolean {
      return !this.isAdmin && this.showResolveRequestButton;
    }

    get showStatusButtonForAdmin(): boolean {
      return this.isAdmin && this.isRequestActive;
    }

    get statusTextForAdmin(): string {
      switch(this.currentStatus) {
        case CustomRequestStatus.UNDER_REVIEW:
          return "Applicants Sent";
        case CustomRequestStatus.APPLICANTS_SENT:
          return "Resolved";
        default:
          return "";
      }
    }

      get requestLink(): RouteParams<{ id: string }> | undefined {
        // const requestId = this.requestId
        if (!this.requestId) {
          return undefined;
        }
        return {
          name: (RouteNames.CUSTOM_REQUEST_DETAILS),
          params: { id: this.requestId }
        }
      }
    

    // message(item: Manager): void {
    //   this.$router.push({
    //     name: RouteNames.INBOX,
    //     query: {
    //       recipientUserId: this.currentUserId,
    //     },
    //   });
    // }

    // message: void {
    //   this.$emit('message')
    // }
    get isRequestActive(): boolean {
      return this.isApplicantsSent || this.isUnderReview;
    }

    get showResolveRequestButton(): boolean {
      return !this.isAdmin && this.isRequestActive;
    }

    async updateRequest(): Promise<void> {
      let status: string = "";

      if (!this.isAdmin) {
        status = CustomRequestStatus.RESOLVED;
      }

      if (this.isAdmin) {
        status =  this.isUnderReview
          ? CustomRequestStatus.APPLICANTS_SENT
          : CustomRequestStatus.RESOLVED;
      }

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_CUSTOM_REQUEST,
          variables: {
            set: {
              status,
              updated_by_id: this.currentUserId,
            },
            id: this.requestId,
          }
        });
        this.$emit("refetch");
      } catch(e) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(e.message)
        );
      }
    }

    toggleRequestModal(): void {
      this.$emit('toggle', !this.modalShown)
    }
  }
